// extracted by mini-css-extract-plugin
module.exports = {"c1afaosy":"c1afaosy"};